import { Icon } from "@iconify/react";
import { IconButton, Rating, Stack, Typography, useTheme } from "@mui/material";

import { imageSource } from "@app/constants";

interface TestimonialProps {
  key?: string | number;
  image?: string;
  testimonial: string;
  name: string;
  position: string;
  rating: number;
  onNext?: () => void;
  onPrev?: () => void;
}

const TestimonialCard = ({
  key,
  image,
  testimonial,
  name,
  position,
  rating,
  onNext,
  onPrev,
}: TestimonialProps) => {
  const theme = useTheme();
  return (
    <Stack
      key={key}
      sx={{
        flexDirection: { xs: "column-reverse", sm: "row" },
        justifyContent: "space-between",
        alignItems: "center",
        py: 3,
      }}
    >
      <Stack
        sx={{
          width: { xs: "100%", sm: "60%" },
          pl: { xs: 1, md: 4 },
          mt: { xs: 2, sm: 0 },
        }}
      >
        <Typography
          sx={{
            height: 180,
            width: "98%",
            overflowY: "scroll",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          {testimonial}
        </Typography>
        <Stack>
          <Typography variant="h6">{name}</Typography>
          <Typography fontSize={14}>{position}</Typography>
          <Rating value={rating} readOnly />
        </Stack>
        <Stack
          sx={{
            flexDirection: "row",
            gap: 1,
            mt: 2,
          }}
        >
          <IconButton
            onClick={onPrev}
            sx={{
              borderRadius: "50%",
              border: 1,
              ":hover": {
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
                color: theme.palette.common.white,
              },
            }}
          >
            <Icon icon={"ooui:next-rtl"} fontSize={14} />
          </IconButton>
          <IconButton
            onClick={onNext}
            sx={{
              borderRadius: "50%",
              border: 1,
              ":hover": {
                backgroundColor: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
                color: theme.palette.common.white,
              },
            }}
          >
            <Icon icon={"ooui:next-ltr"} fontSize={14} />
          </IconButton>
        </Stack>
      </Stack>
      <Stack sx={{ pr: { xs: 0, sm: 5 }, justifyContent: "center" }}>
        <Stack
          sx={{
            width: { xs: 200, md: 250 },
            position: "relative",
            justifyContent: "center",
          }}
        >
          <Stack
            sx={{
              display: { xs: "none", sm: "block" },
              position: "absolute",
              border: `10px solid ${theme.palette.primary.main}`,
              borderLeft: "none",
              width: "80%",
              height: "120%",
              alignSelf: "end",
              right: -25,
            }}
          ></Stack>
          <img
            src={image ? image : imageSource.testimonial}
            alt={name ? name : "Testimonial Image"}
            loading="lazy"
            style={{
              width: "inherit",
              aspectRatio: "1/1",
            }}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export { TestimonialCard };
